import { Fetch } from '../../shared/types';
import type { Authentication } from '../types';

type Params = {
  account_id: number;
  selected_api?: string;
};

type ResponseData = {
  results: Authentication[];
};

const getAuthentications = async (fetch: Fetch, params?: Params) =>
  (
    await fetch<ResponseData>('/api/v4/authentications/', {
      params: {
        ...params,
        limit: 100,
      },
    })
  ).results;

export default getAuthentications;
